import Box from '@material-ui/core/Box';

const Container = (props) => {
  return <Box px={4} py={4} {...props} />;
};

export default Container;
